import React, { useState, useEffect } from 'react';

interface FakeProgressBarProps {
  estimatedTimeMs: number;
  isComplete: boolean;
  className?: string;
}

export const FakeProgressBar: React.FC<FakeProgressBarProps> = ({
  estimatedTimeMs,
  isComplete,
  className = '',
}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (isComplete) {
      setProgress(100);
      return;
    }

    // Reset progress when starting
    setProgress(0);

    const intervalTime = 100; // Update every 100ms
    const totalSteps = estimatedTimeMs / intervalTime;
    const maxProgress = 95; // Stall at 95%
    const incrementPerStep = maxProgress / totalSteps;

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= maxProgress) {
          clearInterval(interval);
          return maxProgress;
        }
        return Math.min(prev + incrementPerStep, maxProgress);
      });
    }, intervalTime);

    return () => clearInterval(interval);
  }, [estimatedTimeMs, isComplete]);

  return (
    <div className={`w-full bg-slate-200 rounded-full h-2.5 overflow-hidden ${className}`}>
      <div
        className="bg-accent h-2.5 rounded-full transition-all duration-300 ease-out"
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  );
};
